<template>
  <v-app>
    <v-content>
		<router-view v-if="!this.$store.getters.isLoading" />
		<Loading v-else opacity="1" />
		<SnackbarNotification v-if="this.$store.getters.notifications.length" />
    </v-content>
  </v-app>
</template>

<script>
import Loading from './components/Loading'
import SnackbarNotification from './components/SnackbarNotification'

export default {
	name: 'App',
	components: {
		Loading,
		SnackbarNotification,
	},
	created() {
		setInterval(() => {
			window.location.reload(true);
		}, 24 * 3600 * 1000);
	},
}
</script>
